import { Provider } from '@angular/core';

import { runOnSportsWebInit } from '@frontend/sports/common/core/feature/app-init';
import { WidgetLayoutHook } from '@frontend/sports/widget/feature/layout';

import { SportLiveButtonService } from './services/sport-live-button.service';
import { SportNavigationHighlightService } from './services/sport-navigation-highlight.service';
import { WidgetRegistrationService } from './services/widget-registration.service';

export function provideCompetitionWidget(): Provider[] {
    return [
        runOnSportsWebInit(WidgetRegistrationService),
        { provide: WidgetLayoutHook, useClass: SportNavigationHighlightService, multi: true },
        { provide: WidgetLayoutHook, useClass: SportLiveButtonService, multi: true },
    ];
}
